import useAuth from '@/auth/useAuth';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { supabase } from '@/lib/supabase';
import HeaderOrganization from './HeaderOrganization';
import HeaderWorkspace from './HeaderWorkspace';
import PATH_PAGE from '@/router/path';
import { Link, useParams } from 'react-router-dom';
import { useGetUser } from '@/service/user/hook';
import { PATH_CONTACT, PATH_DOCS } from '@/constants';
import { Button } from '@/components/ui/button';
import { BookText, ChevronRight, HelpCircleIcon } from 'lucide-react';
import { TooltipAsChild } from '@/components/ui/tooltip';
import ViewCreditMini from '@/pages/setting/payment/view-credit/view-credit-mini';
import { useDemoMode } from '@/context/DemoModeContext';
import { RouteParams } from '@/router/type';

const Header = () => {
  const { session } = useAuth();
  const { data } = useGetUser({
    enabled: false,
  });
  const user = session?.user;
  const email = user?.email;
  const name = data?.name as string;
  const avatarUrl = user?.user_metadata?.avatar_url;
  const shortName = email?.slice(0, 2).toUpperCase();

  const handleLogout = async () => {
    await supabase.auth.signOut();
  };

  const list = [
    {
      name: 'Settings',
      href: PATH_PAGE.setting.profile,
      onClick: () => {},
    },
    // {
    //   name: 'Terms & policies',
    //   onClick: () => console.log('Terms & policies'),
    // },
  ];

  const { isDemoMode } = useDemoMode();
  const { orgId } = useParams<RouteParams>();

  return (
    <>
      <div className="flex items-center gap-1">
        <HeaderOrganization />
        {isDemoMode && orgId && (
          <>
            <ChevronRight className="h-4 w-4 text-muted-foreground" />
            <HeaderWorkspace />
          </>
        )}
        {!isDemoMode && <HeaderWorkspace />}
      </div>
      <div className="flex w-full items-center gap-4 md:ml-auto md:gap-2 lg:gap-4">
        <div className="ml-auto"></div>
        <div className='hidden md:block'>
          <ViewCreditMini />
        </div>
        <TooltipAsChild content="Docs">
          <Link
            to={PATH_DOCS.root}
            className="underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            <BookText className="h-4 w-4" />
          </Link>
        </TooltipAsChild>

        <TooltipAsChild content="Help">
          <Link
            to={PATH_CONTACT.support}
            className="underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            <HelpCircleIcon className="h-4 w-4" />
          </Link>
        </TooltipAsChild>

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Avatar className="h-8 w-8 cursor-pointer">
              <AvatarImage
                src={avatarUrl}
                alt="profile"
                referrerPolicy="no-referrer"
              />
              <AvatarFallback>{shortName}</AvatarFallback>
            </Avatar>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="mr-2">
            <DropdownMenuLabel>
              <div className="flex flex-col gap-1">
                {name && <p className="">{name}</p>}
                <p className="text-xs font-normal">{email}</p>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            {/* <DropdownMenuLabel className="font-normal">
              <div className="flex items-center justify-between gap-1">
                Theme <ModeToggle />
              </div>
            </DropdownMenuLabel> */}
            {list.map((item, index) =>
              item.href ? (
                <Link key={index} to={item.href}>
                  <DropdownMenuItem key={index} onClick={item?.onClick}>
                    {item.name}
                  </DropdownMenuItem>
                </Link>
              ) : (
                <DropdownMenuItem key={index} onClick={item.onClick}>
                  {item.name}
                </DropdownMenuItem>
              )
            )}
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onClick={handleLogout}
              className="focus:bg-red-300/40"
            >
              Logout
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </>
  );
};

export default Header;
